module.exports = __webpack_public_path__ + "img/EST.e117f1a6.svg";